/*
Copyright 2022 Fondazione Bruno Kessler
Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
except in compliance with the Licence.

You may obtain a copy of the Licence at:
http://ec.europa.eu/idabc/eupl.html

Unless required by applicable law or agreed to in writing, software distributed under 
the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF 
ANY KIND, either express or implied. See the Licence for the specific language 
governing permissions and limitations under the Licence.
*/

import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {CommonState} from '@app/store/common/common.state';
import {ModalController} from '@ionic/angular';
import {Store} from '@ngxs/store';
import {SaluteProxyService, TrecError} from '@trec/api';
import {C3SnackbarStatusService} from '@trec/components/snackbar-status';
import {CheckAppointment} from './check-appointment';

@Component({
  selector: 'app-dialog-delete-appointments',
  templateUrl: './dialog-delete-appointments.component.html',
  styleUrls: ['./dialog-delete-appointments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DialogDeleteAppointmentsComponent implements OnInit {

  @Input()
  data: any;

  appointments: CheckAppointment[] = [];
  loading = false;

  constructor(private modalCtrl: ModalController, private saluteProxyService: SaluteProxyService, private store: Store,
    private c3Statusbar: C3SnackbarStatusService) { }

  ngOnInit(): void {
    this.appointments = this.data.appointments;
  }

  onClose() {
    this.modalCtrl.dismiss();
  }

  cancellaAppuntamenti() {

    this.loading = true;
    let ids = "";
    for (let i = 0; i < this.appointments.length; i++) {
      if (this.appointments[i].checked) {
        ids = ids + ", " + this.appointments[i].appointmentCode;
      }
    }
    if (ids.length > 0) {

      ids = ids.substring(1, ids.length);

      const patient = this.store.selectSnapshot(CommonState.patient);
      this.saluteProxyService.deleteAppointments(patient!.trecUserId, ids).subscribe((ids) => {

        if (ids.length === 0) {
          this.c3Statusbar.showSuccess({message: `Appuntamenti cancellati correttamente`});
          this.modalCtrl.dismiss();
        } else {
          this.c3Statusbar.showError(
            {
              error: new TrecError("100", "Non è stato possibile cancellare i seguenti appuntamenti: " + ids.join(', ')),
              messagesMap: {},
              hideDetails: true,
              hideKibanaBtn: true,
            }
          );
        }

      });

    }

  }

}
